import { useState, useEffect, useRef } from "react";
import { api } from "@/services/api";
import { uploadFile, uploadBrochure } from "@/services/upload";

const TYPE_OPTIONS = ["villa", "cottage", "duplex", "commercial"];
const STATUS_OPTIONS = ["available", "sold", "rented", "under-construction", "off-market"];
const PURPOSE_OPTIONS = ["sale", "rent", "investment"];
const STATE_OPTIONS = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
  "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
  "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
  "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh",
  "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir",
  "Ladakh", "Lakshadweep", "Puducherry"
];
const REGION_OPTIONS = ["All", "South India", "North India", "West India", "East India", "Central India", "Northeast India"];

const CITY_BY_STATE: Record<string, string[]> = {
  "Metro & Tier 1": [
    "Mumbai", "Delhi", "Bangalore", "Hyderabad", "Ahmedabad", "Chennai", "Kolkata", "Surat",
    "Pune", "Jaipur", "Lucknow", "Kanpur", "Nagpur", "Indore", "Thane", "Bhopal",
    "Visakhapatnam", "Vadodara", "Firozabad", "Ludhiana", "Rajkot", "Agra",
    "Faridabad", "Meerut", "Jodhpur", "Raipur", "Kota", "Coimbatore",
    "Amritsar", "Ranchi", "Gwalior", "Bhubaneswar", "Jalandhar", "Patna",
    "Chandigarh", "Nashik", "Vijayawada", "Madurai", "Varanasi", "Mysore",
    "Thiruvananthapuram", "Dehradun", "Kochi", "Guwahati", "Siliguri", "Durgapur",
  ],
  "Himachal Pradesh": [
    "Shimla", "Manali", "Dharamshala", "McLeod Ganj", "Dalhousie", "Khajjiar",
    "Kasauli", "Kufri", "Solan", "Mandi", "Chamba", "Kinnaur", "Spiti Valley",
    "Manikaran", "Tirthan Valley", "Barot", "Bir Billing", "Palampur", "Narkanda",
  ],
  "Uttarakhand": [
    "Mussoorie", "Nainital", "Rishikesh", "Haridwar", "Almora", "Ranikhet",
    "Binsar", "Kausani", "Lansdowne", "Chopta", "Auli", "Pithoragarh", "Chamoli",
    "Pauri", "Tehri", "Bhimtal", "Sattal", "Mukteshwar", "Ramgarh", "Harsil",
  ],
  "Jammu and Kashmir": [
    "Srinagar", "Gulmarg", "Pahalgam", "Sonamarg", "Patnitop", "Katra",
  ],
  "Ladakh": [
    "Leh", "Ladakh City", "Ladakh Valley", "Nubra Valley", "Pangong Lake", "Zanskar",
    "Kargil", "Dras", "Sanasar", "Bhadarwah",
  ],
  "Sikkim": [
    "Gangtok", "Pelling", "Lachung", "Lachen", "Yuksom", "Ravangla", "Namchi",
  ],
  "West Bengal": [
    "Darjeeling", "Kalimpong", "Lava", "Loleygaon", "Rishop", "Sandakphu",
    "Mirik", "Kurseong", "Siliguri", "Jalpaiguri", "Sundarbans", "Bakkhali",
    "Mandarmani", "Digha", "Tajpur", "Shantiniketan", "Bishnupur", "Murshidabad",
    "Cooch Behar", "Alipurduar", "Malda", "Bankura", "Purulia", "Ayodhya Hills",
  ],
  "Assam": ["Shillong", "Cherrapunji", "Mawlynnong", "Dawki", "Jowai", "Tura"],
  "Arunachal Pradesh": ["Tawang", "Bomdila", "Dirang", "Ziro", "Itanagar", "Pasighat", "Namdapha"],
  "Meghalaya": ["Shillong", "Cherrapunji", "Mawlynnong", "Dawki", "Jowai", "Tura"],
  "Nagaland": ["Kohima", "Dzukou Valley", "Mokokchung"],
  "Mizoram": ["Aizawl", "Champhai", "Lunglei"],
  "Manipur": ["Imphal", "Ukhrul", "Churachandpur"],
  "Tripura": ["Agartala", "Udaipur", "Unakoti"],
  "Rajasthan": [
    "Udaipur", "Jaisalmer", "Pushkar", "Ajmer", "Bikaner", "Mount Abu",
    "Ranthambore", "Bharatpur", "Kumbhalgarh", "Chittorgarh", "Jaisalmer Dunes",
    "Sawai Madhopur", "Alwar", "Neemrana", "Sariska",
  ],
  "Gujarat": [
    "Saputara", "Wilson Hills", "Girnar", "Pavagadh", "Statue of Unity",
    "Kutch", "Dwarka", "Somnath", "Diu", "Daman",
  ],
  "Maharashtra": [
    "Mahabaleshwar", "Panchgani", "Matheran", "Amboli", "Lonavala", "Khandala",
    "Igatpuri", "Bhandardara", "Rajmachi", "Lavasa", "Mulshi", "Tamhini Ghat",
    "Malshej Ghat", "Jawhar", "Satara", "Sajjangad", "Torna", "Ratnagiri",
    "Sindhudurg", "Malvan", "Tarkarli", "Dapoli", "Harihareshwar", "Murud",
    "Alibaug", "Kashid", "Revdanda", "Srivardhan", "Guhagar", "Ganpatipule",
    "Chiplun", "Koyna", "Mahabaleshwar Valley", "Kolhapur", "Sangli",
    "Aurangabad", "Amravati", "Nanded", "Solapur", "Nagpur", "Wardha",
    "Mumbai", "Pune", "Nashik", "Thane", "Navi Mumbai", "Kalyan",
  ],
  "Goa": [
    "Panaji", "Margao", "Vasco", "Mapusa", "Ponda", "Calangute", "Candolim",
    "Baga", "Anjuna", "Vagator", "Palolem", "Agonda", "Colva", "Benaulim",
    "Cansaulim", "Varca", "Mobor", "Majorda", "Utorda", "Betalbatim",
  ],
  "Karnataka": [
    "Madikeri", "Coorg", "Virajpet", "Somwarpet", "Chikmagalur", "Sringeri",
    "Agumbe", "Jog Falls", "Kodachadri", "Kundapura", "Mangalore", "Udupi",
    "Karwar", "Gokarna", "Dandeli", "Belgaum", "Hassan", "Sakleshpur",
    "Kalasa", "Kudremukh", "Charmadi Ghat", "Bababudangiri", "Kemmangundi",
    "Shivamogga", "Sagara", "Honnemaradu", "Talakaveri", "Bhadra", "Tadiyandamol",
    "Bangalore", "Mysore",
  ],
  "Kerala": [
    "Munnar", "Wayanad", "Kalpetta", "Thekkady", "Vagamon", "Ponmudi",
    "Athirappilly", "Idukki", "Devikulam", "Peermade", "Nelliyampathy",
    "Ranipuram", "Thiruvambady", "Gavi", "Thenmala", "Konni", "Kuttanad",
    "Alleppey", "Kumarakom", "Kochi", "Kannur", "Kasaragod", "Bekal",
    "Varkala", "Kovalam", "Poovar", "Marari", "Cherai", "Fort Kochi",
    "Sultan Bathery", "Mananthavady", "Meenmutty", "Soochipara", "Pookode Lake",
    "Thiruvananthapuram",
  ],
  "Tamil Nadu": [
    "Ooty", "Coonoor", "Kotagiri", "Gudalur", "Manjoor", "Glenmorgan",
    "Masinagudi", "Kodaikanal", "Yercaud", "Kolli Hills", "Pachamalai",
    "Javadi Hills", "Shevaroy Hills", "Kalrayan Hills", "Valparai",
    "Pollachi", "Palani", "Courtallam", "Megamalai", "Manimuthar",
    "Tirunelveli", "Tenkasi", "Kanyakumari", "Rameswaram", "Pamban",
    "Thanjavur", "Tirupati", "Madurai", "Mahabalipuram", "Kanchipuram",
    "Pondicherry", "Auroville", "Chidambaram", "Velankanni", "Kumbakonam",
    "Chennai", "Coimbatore",
  ],
  "Andhra Pradesh": [
    "Araku Valley", "Horsley Hills", "Lambasingi", "Paderu", "Maredumilli",
    "Chintapalli", "Ananthagiri", "Vizag", "Vishakhapatnam", "Rajahmundry",
    "Tirupati", "Srisailam", "Ahobilam", "Nallamala", "Nagarjuna Sagar",
    "Vijayawada",
  ],
  "Telangana": [
    "Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Mahabubnagar",
    "Khammam", "Medak", "Bhongir", "Adilabad", "Nirmal",
  ],
  "Odisha": [
    "Koraput", "Rayagada", "Daringbadi", "Phulbani", "Baliguda",
    "Malkangiri", "Jeypore", "Gunupur", "Puri", "Konark", "Chilika",
    "Gopalpur", "Satkosia", "Similipal", "Bhitarkanika", "Rourkela",
    "Keonjhar", "Sambalpur", "Bolangir", "Baripada", "Bhubaneswar",
  ],
  "Madhya Pradesh": [
    "Pachmarhi", "Amarkantak", "Mandu", "Jabalpur", "Bhedaghat", "Kanha",
    "Bandhavgarh", "Pench", "Satpura", "Bhopal", "Indore", "Ujjain",
    "Gwalior", "Orchha", "Khajuraho", "Chitrakoot", "Shivpuri",
  ],
  "Chhattisgarh": [
    "Mainpat", "Chirmiri", "Ambikapur", "Bastar", "Jagdalpur", "Kanger Valley",
    "Raipur",
  ],
  "Jharkhand": [
    "Netarhat", "Betla", "Deoghar", "Hazaribagh", "Jamshedpur", "Ranchi",
  ],
  "Bihar": [
    "Rajgir", "Bodh Gaya", "Nalanda", "Valmiki Nagar", "Patna",
  ],
  "Punjab": [
    "Amritsar", "Ludhiana", "Jalandhar", "Patiala", "Pathankot",
  ],
  "Haryana": [
    "Gurgaon", "Faridabad", "Panchkula", "Kurukshetra", "Morni Hills",
    "Kasauli", "Pinjore", "Chail", "Solan", "Nahan",
  ],
  "Uttar Pradesh": [
    "Agra", "Varanasi", "Allahabad", "Lucknow", "Kanpur", "Mathura",
    "Vrindavan", "Ayodhya", "Sarnath", "Kushinagar", "Jhansi", "Chitrakoot",
    "Dudhwa", "Nainital UP", "Ranikhet UP", "Kausani UP",
  ],
  "Delhi": ["Delhi", "New Delhi", "Noida", "Greater Noida", "Faridabad"],
  "Chandigarh": ["Chandigarh", "Mohali", "Panchkula"],
};

const ALL_CITIES = Object.values(CITY_BY_STATE).flat();

interface ImageItem { url: string; caption: string; is_primary: boolean; }

function slugify(str: string): string {
  return (str || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}

function CityAutocomplete({
  value,
  onChange,
  onSelect,
  showSuggestions,
  setShowSuggestions,
  inputRef,
  selectedState,
}: {
  value: string;
  onChange: (v: string) => void;
  onSelect: (v: string) => void;
  showSuggestions: boolean;
  setShowSuggestions: (v: boolean) => void;
  inputRef: React.RefObject<HTMLDivElement | null>;
  selectedState: string;
}) {
  const cityPool = selectedState && CITY_BY_STATE[selectedState]
    ? CITY_BY_STATE[selectedState]
    : ALL_CITIES;

  const filtered = value.trim().length > 0
    ? cityPool.filter((c) => c.toLowerCase().includes(value.toLowerCase())).slice(0, 8)
    : [];

  return (
    <div className="relative" ref={inputRef}>
      <label className="block text-xs font-semibold text-foreground-800 mb-1.5">City</label>
      <input
        type="text"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setShowSuggestions(true);
        }}
        onFocus={() => setShowSuggestions(true)}
        placeholder={selectedState ? `Search cities in ${selectedState}...` : "Type to search cities..."}
        className="w-full rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
      />
      {showSuggestions && filtered.length > 0 && (
        <div className="absolute z-10 mt-1 w-full rounded-lg border border-background-200 bg-background-50 shadow-lg max-h-48 overflow-y-auto">
          {filtered.map((city) => (
            <button
              key={city}
              type="button"
              onClick={() => onSelect(city)}
              className="w-full text-left px-3 py-2 text-sm text-foreground-800 hover:bg-background-100 first:rounded-t-lg last:rounded-b-lg"
            >
              {city}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function PropertyModal({
  mode,
  id,
  onClose,
  onSaved,
}: {
  mode: "create" | "edit";
  id?: number;
  onClose: () => void;
  onSaved: () => void;
}) {
  const [form, setForm] = useState({
    title: "", type: "villa", purpose: "investment", status: "available",
    price: "", currency: "INR", city: "", state: "", region: "", location: "", description: "",
    bedrooms: "", bathrooms: "", built_up_area: "", plot_area: "", expected_yield: "",
    brochure: "",
  });
  const [slug, setSlug] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [images, setImages] = useState<ImageItem[]>([]);
  const [uploading, setUploading] = useState(false);
  const [brochureUploading, setBrochureUploading] = useState(false);
  const [cityQuery, setCityQuery] = useState("");
  const [showCitySuggestions, setShowCitySuggestions] = useState(false);
  const cityInputRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      const target = e.target as Node;
      if (cityInputRef.current && !cityInputRef.current.contains(target)) {
        setShowCitySuggestions(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  useEffect(() => {
    if (mode === "edit" && id) {
      api.get<any>(`/properties/${id}`)
        .then((p) => {
          setSlug(p.slug || "");
          setCityQuery(p.city || "");
          setForm({
            title: p.title, type: p.type, purpose: p.purpose, status: p.status,
            price: p.price, currency: p.currency, city: p.city || "", state: p.state || "",
            region: p.region || "", location: p.location || "", description: p.description || "",
            bedrooms: p.bedrooms ?? "", bathrooms: p.bathrooms ?? "",
            built_up_area: p.built_up_area ?? "", plot_area: p.plot_area ?? "",
            expected_yield: p.expected_yield ?? "",
            brochure: p.brochure || "",
          });
          if (Array.isArray(p.images)) {
            setImages(
              p.images
                .slice()
                .sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0))
                .map((img: any) => ({ url: img.url, caption: img.caption || "", is_primary: !!img.is_primary }))
            );
          }
        })
        .catch((e) => setError(e?.message || "Failed to load property"));
    }
  }, [mode, id]);

  function update(key: string, value: string) {
    setForm((f) => ({ ...f, [key]: value }));
  }

  async function onFiles(e: React.ChangeEvent<HTMLInputElement>) {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    setError("");
    try {
      const first = images.length === 0;
      for (const file of files) {
        const up = await uploadFile(file);
        setImages((list) => [
          ...list,
          { url: up.url, caption: "", is_primary: first && list.length === 0 },
        ]);
      }
    } catch (err: any) {
      setError(err?.message || "Upload failed");
    } finally {
      setUploading(false);
      if (e.target) e.target.value = "";
    }
  }

  function removeImage(index: number) {
    setImages((list) => list.filter((_, i) => i !== index));
  }

  function setPrimary(index: number) {
    setImages((list) => list.map((img, i) => ({ ...img, is_primary: i === index })));
  }

  function updateCaption(index: number, caption: string) {
    setImages((list) => list.map((img, i) => (i === index ? { ...img, caption } : img)));
  }

  async function onBrochureFile(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    setBrochureUploading(true);
    setError("");
    try {
      const up = await uploadBrochure(file, slug || slugify(form.title));
      update("brochure", up.url);
    } catch (err: any) {
      setError(err?.message || "Brochure upload failed");
    } finally {
      setBrochureUploading(false);
      if (e.target) e.target.value = "";
    }
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError("");
    const payload = { ...form, images: images.map((img, i) => ({ ...img, sort_order: i })) };
    try {
      if (mode === "create") await api.post("/properties", payload);
      else await api.put(`/properties/${id}`, payload);
      onSaved();
    } catch (err: any) {
      setError(err?.message || "Save failed");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-2xl rounded-3xl bg-background-50 border border-background-200 shadow-xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b border-background-100 sticky top-0 bg-background-50">
          <h3 className="font-heading text-lg text-foreground-950">
            {mode === "create" ? "Add Project" : "Edit Project"}
          </h3>
          <button onClick={onClose} className="flex items-center justify-center w-8 h-8 rounded-lg text-foreground-600 hover:bg-background-100" aria-label="Close">
            <i className="ri-close-line"></i>
          </button>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          {error && (
            <div className="rounded-lg bg-accent-100 border border-accent-300 px-4 py-3 text-sm text-accent-900">{error}</div>
          )}
          <div>
            <label className="block text-xs font-semibold text-foreground-800 mb-1.5">Project Title *</label>
            <input
              required
              value={form.title}
              onChange={(e) => update("title", e.target.value)}
              className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <Field label="Type" value={form.type} onChange={(v) => update("type", v)} select options={TYPE_OPTIONS} />
            <Field label="Purpose" value={form.purpose} onChange={(v) => update("purpose", v)} select options={PURPOSE_OPTIONS} />
            <Field label="Status" value={form.status} onChange={(v) => update("status", v)} select options={STATUS_OPTIONS} />
            <Field label="Price" value={form.price} onChange={(v) => update("price", v)} type="number" />
            <Field label="Currency" value={form.currency} onChange={(v) => update("currency", v)} />
            <Field label="Expected Yield (%)" value={form.expected_yield} onChange={(v) => update("expected_yield", v)} type="number" />
            <CityAutocomplete
              value={cityQuery}
              onChange={(v) => {
                setCityQuery(v);
                update("city", v);
              }}
              onSelect={(v) => {
                setCityQuery(v);
                update("city", v);
                setShowCitySuggestions(false);
              }}
              showSuggestions={showCitySuggestions}
              setShowSuggestions={setShowCitySuggestions}
              inputRef={cityInputRef}
              selectedState={form.state}
            />
            <Field
              label="State"
              value={form.state}
              onChange={(v) => {
                update("state", v);
                const pool = v && CITY_BY_STATE[v] ? CITY_BY_STATE[v] : ALL_CITIES;
                if (cityQuery && !pool.includes(cityQuery)) {
                  setCityQuery("");
                  update("city", "");
                }
              }}
              select
              options={STATE_OPTIONS}
            />
            <Field label="Region" value={form.region} onChange={(v) => update("region", v)} select options={REGION_OPTIONS} />
            <Field label="Bedrooms" value={form.bedrooms} onChange={(v) => update("bedrooms", v)} type="number" />
            <Field label="Bathrooms" value={form.bathrooms} onChange={(v) => update("bathrooms", v)} type="number" />
            <Field label="Built-up Area" value={form.built_up_area} onChange={(v) => update("built_up_area", v)} type="number" />
            <Field label="Plot Area" value={form.plot_area} onChange={(v) => update("plot_area", v)} type="number" />
          </div>

          <div>
            <label className="block text-xs font-semibold text-foreground-800 mb-2">Project Images</label>
            <div className="rounded-2xl border-2 border-dashed border-background-300 p-4 text-center">
              <input type="file" id="property-images" accept="image/*" multiple onChange={onFiles} className="hidden" />
              <label htmlFor="property-images" className="cursor-pointer inline-flex flex-col items-center gap-1.5">
                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-primary-100 text-primary-700"><i className={uploading ? "ri-loader-4-line animate-spin" : "ri-image-add-line"}></i></span>
                <span className="text-sm font-semibold text-foreground-900">{uploading ? "Uploading..." : "Upload images"}</span>
                <span className="text-xs text-foreground-600">PNG, JPG or WebP up to 8MB each</span>
              </label>
            </div>
            {images.length > 0 && (
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-3">
                {images.map((img, i) => (
                  <div key={`${img.url}-${i}`} className="rounded-xl overflow-hidden border border-background-200 bg-background-50">
                    <div className="relative aspect-[4/3] w-full bg-background-100">
                      <img src={img.url} alt={img.caption || "Property"} className="w-full h-full object-cover" />
                      {img.is_primary && (
                        <span className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-full bg-accent-500 text-background-50 px-2 py-0.5 text-[10px] font-bold"><i className="ri-star-fill"></i> Primary</span>
                      )}
                      <button type="button" onClick={() => removeImage(i)} className="absolute top-2 right-2 flex items-center justify-center w-7 h-7 rounded-lg bg-black/50 text-white hover:bg-accent-600" aria-label="Remove image"><i className="ri-close-line"></i></button>
                    </div>
                    <div className="p-2 space-y-1.5">
                      <input value={img.caption} onChange={(e) => updateCaption(i, e.target.value)} placeholder="Caption" className="w-full rounded-md border border-background-200 bg-background-50 px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-primary-400" />
                      {!img.is_primary && (
                        <button type="button" onClick={() => setPrimary(i)} className="w-full text-xs font-semibold rounded-md bg-secondary-100 text-secondary-900 px-2 py-1.5 hover:bg-secondary-200">
                          Set as primary
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div>
            <label className="block text-xs font-semibold text-foreground-800 mb-2">Project Brochure (PDF)</label>
            <div className="flex flex-col sm:flex-row sm:items-center gap-3">
              <label
                htmlFor="property-brochure"
                className="inline-flex items-center gap-2 rounded-lg border-2 border-dashed border-background-300 px-4 py-2.5 text-sm font-semibold text-foreground-800 cursor-pointer hover:border-primary-400 hover:text-primary-700 transition-colors"
              >
                <i className={brochureUploading ? "ri-loader-4-line animate-spin" : "ri-file-pdf-2-line"}></i>
                {brochureUploading ? "Uploading..." : form.brochure ? "Replace brochure" : "Upload brochure PDF"}
              </label>
              <input type="file" id="property-brochure" accept="application/pdf" onChange={onBrochureFile} className="hidden" />
              {form.brochure ? (
                <div className="flex items-center gap-3 text-xs">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-3 py-1 font-medium">
                    <i className="ri-check-line"></i> Brochure saved
                  </span>
                  <a href={form.brochure} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-primary-700 hover:text-primary-800">
                    <i className="ri-external-link-line"></i> View
                  </a>
                  <button type="button" onClick={() => update("brochure", "")} className="inline-flex items-center gap-1 text-accent-700 hover:text-accent-800">
                    <i className="ri-close-circle-line"></i> Remove
                  </button>
                </div>
              ) : (
                <p className="text-xs text-foreground-600">Saved to /downloads as a stable PDF link.</p>
              )}
            </div>
          </div>

          <div>
            <label className="block text-xs font-semibold text-foreground-800 mb-1.5">Description</label>
            <textarea
              rows={4}
              value={form.description}
              onChange={(e) => update("description", e.target.value)}
              maxLength={2000}
              className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 resize-none"
            ></textarea>
          </div>
          <div className="flex items-center justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-background-300 text-foreground-800 px-5 py-2.5 hover:bg-background-100">
              Cancel
            </button>
            <button type="submit" disabled={saving} className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-600 text-background-50 px-5 py-2.5 hover:bg-primary-700 disabled:opacity-60">
              {saving ? <><i className="ri-loader-4-line animate-spin"></i> Saving...</> : "Save Project"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", select, options = [] }: {
  label: string; value: string; onChange: (v: string) => void; type?: string; select?: boolean; options?: string[];
}) {
  return (
    <div>
      <label className="block text-xs font-semibold text-foreground-800 mb-1.5">{label}</label>
      {select ? (
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
        >
          <option value="" disabled>-- Select {label} --</option>
          {options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
        />
      )}
    </div>
  );
}